import React from "react";
import SEO from "./SEO";
import Header from "./Header";
import Footer from "./Footer";
import ServiceSide from "./ServiceSide";
import { NavLink } from "react-router-dom";

function Services() {
  return (
    <>
      <SEO
        title="Mobile App Development Services | Android & iOS App Solutions – Moironix"
        description="Get Expert Mobile App Development Services at Moironix. We Build Custom Android & IOS Apps, Hybrid Solutions, and Enterprise Mobile Applications"
        keywords="Mobile App Development, Custom Mobile App Development Hyderabad, Hybrid App Development Cost, React Native App Development Services, Flutter App Development for Startups, Mobile App Prototype Development, Mobile App Development Company, Android App Development Services, IOS App Development Services, Mobile App Developers, App Development Agency, Enterprise Mobile App Development"
      />
      <Header />
      <div className="prt-page-title-row style1">
        <div className="prt-page-title-row-inner">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="prt-page-title-row-heading">
                  <div className="banner-vertical-block" />
                  <div className="page-title-heading">
                    <h2 className="title">Mobile Application Development</h2>
                  </div>
                  <div className="breadcrumb-wrapper">
                    <span>
                      <NavLink title="Homepage" to="/">
                        Home
                      </NavLink>
                    </span>
                    <span className="action">
                      Mobile Application Development
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <>
        <div className="site-main">
          <div className="prt-row sidebar prt-sidebar-left clearfix">
            <div className="container">
              <div className="row">
                <div className="widget-area sidebar-left prtcol-bgcolor-yes prt-bg prt-left-span bg-base-grey">
                  <ServiceSide />
                </div>
                <div className="col-lg-8 content-area">
                  <div className="prt-service-single-content-area">
                    <div className="prt_fatured_image-wrapper mb-40 res-575-mb-20">
                      <img
                        width={859}
                        height={440}
                        className="img-fluid"
                        src="images/d2.jpeg"
                        alt="services-1"
                      />
                    </div>
                    <div className="prt-service-description">
                      <h3>Mobile Application Development</h3>
                      <p>
                        At Moironix Soft Solutions, we specialize in delivering
                        top-notch mobile application development services that
                        empower businesses to stay ahead in today’s digital
                        landscape. Our team of expert developers and designers
                        is committed to creating innovative, user-friendly, and
                        scalable mobile applications tailored to meet your
                        unique business needs.
                      </p>
                      <div className="row">
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                          <ul className="service-detail-list">
                            <li className="service-detail-list-item">
                              <div className="service-detail-list-text">
                                Custom Mobile App Development
                              </div>
                            </li>
                            <li className="service-detail-list-item">
                              <div className="service-detail-list-text">
                                iOS App Development
                              </div>
                            </li>
                          </ul>
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                          <div>
                            <ul className="service-detail-list">
                              <li className="service-detail-list-item">
                                <div className="service-detail-list-text">
                                  Android App Development
                                </div>
                              </li>
                              <li className="service-detail-list-item">
                                <div className="service-detail-list-text">
                                  Graphic Design
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                          <div>
                            <ul className="service-detail-list">
                              <li className="service-detail-list-item">
                                <div className="service-detail-list-text">
                                  Full-Stack Development
                                </div>
                              </li>
                            </ul>
                          </div>
                          <div>
                            <ul className="service-detail-list">
                              <li className="service-detail-list-item">
                                <div className="service-detail-list-text">
                                  E-commerce Solutions
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                          <div>
                            <ul className="service-detail-list">
                              <li className="service-detail-list-item">
                                <div className="service-detail-list-text">
                                  SEO-Friendly Development
                                </div>
                              </li>
                            </ul>
                          </div>
                          <div>
                            <ul className="service-detail-list">
                              <li className="service-detail-list-item">
                                <div className="service-detail-list-text">
                                  Content Management Systems (CMS)
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
      <Footer />
    </>
  );
}

export default Services;
